var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Subheader", {
        attrs: { title: "Guidelines", search: "guidelines" },
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-alert",
                {
                  staticClass: "ma-0",
                  attrs: {
                    value: true,
                    color: "warning lighten-2",
                    icon: "warning",
                    outline: "",
                  },
                },
                [
                  _c("span", { staticClass: "primary--text py-2" }, [
                    _vm._v(
                      "\n          Highlighted guidelines have one or more standards without any analyte links assigned.\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.GuidelineList,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("tr", { class: [_vm.getColor(props.item)] }, [
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(props.item.GuidelineLongName) +
                                " (" +
                                _vm._s(props.item.GuidelineName) +
                                ")"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.Category)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.MediasString)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(
                              _vm._s(
                                props.item.LastModifiedDateTime != null
                                  ? _vm.formatDate(
                                      props.item.LastModifiedDateTime,
                                      _vm.prettyDateTimeFormat
                                    )
                                  : ""
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-right" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    to: {
                                      name: "tenantGuidelinesDetail",
                                      params: {
                                        name: props.item.GuidelineName,
                                      },
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { color: "warning" },
                                    },
                                    [_vm._v("edit")]
                                  ),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("Button.Edit")) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }